import React from "react";
import { Card } from "antd";
import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

export default function AgeCard() {
    const { t } = useTranslation();
    // ===== MOCK DATA =====
    const data = [
        { label: t('customer_report.under_18'), value: 5, revenue: 500000, color: "#facc15" },
        { label: t('customer_report.age_18_24'), value: 12, revenue: 2400000, color: "#f59e0b" },
        { label: t('customer_report.age_25_34'), value: 20, revenue: 5000000, color: "#fb923c" },
        { label: t('customer_report.age_35_44'), value: 15, revenue: 3500000, color: "#f97316" },
        { label: t('customer_report.age_45_54'), value: 8, revenue: 2000000, color: "#ef4444" },
        { label: t('customer_report.over_55'), value: 4, revenue: 1000000, color: "#dc2626" },
        { label: t('customer_report.no_data'), value: 2, revenue: 300000, color: "#d1d5db" },
    ];

    const totalRevenue = data.reduce((sum, i) => sum + i.revenue, 0);

    const format = (n: number) => n.toLocaleString("vi-VN") + " đ";

    // ===== CHART OPTION =====
    const option = {
        tooltip: {
            trigger: "item",
            formatter: (params: any) => {
                return `
          <b>${params.name}</b><br/>
          ${t('customer_report.tooltip_quantity')}: ${params.value}<br/>
          ${t('customer_report.tooltip_ratio')}: ${params.percent}%
        `;
            },
        },

        series: [
            {
                type: "pie",
                radius: ["75%", "90%"], // 👈 to hơn
                label: { show: false },

                emphasis: {
                    scale: true,
                    scaleSize: 10,
                },

                data: data.map((i) => ({
                    value: i.value,
                    name: i.label,
                    itemStyle: { color: i.color },
                })),
            },
        ],
    };

    return (
        <Card
            title={t('customer_report.age')}
            className="dark:!text-white"
        >
            {/* ===== CHART ===== */}
            <div className="relative flex justify-center">
                <ReactECharts option={option} style={{ height: 300, width: 300 }} />

                {/* CENTER TEXT */}
                <div className="absolute inset-0 flex items-center justify-center flex-col pointer-events-none">
                    <div className="text-gray-400 dark:text-gray-400 text-sm">{t('customer_report.revenue')}</div>
                    <div className="font-semibold text-lg text-black dark:text-white">
                        {format(totalRevenue)}
                    </div>
                </div>
            </div>

            {/* ===== HEADER ===== */}
            <div className="grid grid-cols-3 text-sm mt-8 font-medium text-gray-500 dark:text-gray-400">
                <div>{t('customer_report.age')}</div>
                <div className="text-center">{t('customer_report.quantity')}</div>
                <div className="text-right">{t('customer_report.revenue')}</div>
            </div>

            {/* ===== LIST ===== */}
            {data.map((item) => (
                <div
                    key={item.label}
                    className="grid grid-cols-3 text-sm mt-3 items-center text-gray-800 dark:text-gray-200"
                >
                    <div className="flex items-center gap-2">
                        <span
                            className="w-3 h-3 rounded-sm"
                            style={{ background: item.color }}
                        />
                        {item.label}
                    </div>

                    <div className="text-center">{item.value}</div>
                    <div className="text-right">{format(item.revenue)}</div>
                </div>
            ))}
        </Card>
    );
}